import { signupSchema } from "../screens/home/schemas";
import { BaseService } from "./BaseService";
const config = require("../../config");
import { CognitoUser } from "amazon-cognito-identity-js";
import { formatCognitoPhoneNumber } from "../utils/phoneNumber";
import publicIP from "react-native-public-ip";
const accountServiceUrl = config.domusoApiService;
import Constants from "expo-constants";

export class UserService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (any: any) => {},
    public url = accountServiceUrl
  ) {
    super(url, cognitoUser, dispatch);
  }
  static async signUp({
    email,
    prop_id,
    first_name: given_name,
    last_name: family_name,
    phone,
  }: any) {
    const res = await fetch(`${accountServiceUrl}/v1/signup`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      body: JSON.stringify({
        email,
        prop_id,
        family_name,
        given_name,
        phone_number: phone,
        source: "mobile",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const json = await res.json();
    if (res.status === 500) {
      const { message, stackTrace } = json;
      throw new Error(JSON.stringify({ message, stackTrace }));
    }
    return json;
  }

  async sendFootprints({ username, interaction_type, payment_schedule_id = null, channel }: any) {
    const userAgent = await Constants.getWebViewUserAgentAsync();
    publicIP().then((ip_address) => {
      const platform =
        Constants.platform?.android || Constants.platform?.ios || Constants.platform?.web || {};
      const extras = JSON.stringify({
        userAgent,
        platform,
        deviceName: Constants.deviceName,
        appVersion: Constants?.expoConfig?.version,
      });
      const body = {
        ip_address,
        interaction_type,
        extras,
        channel,
        payment_schedule_id,
      };
      this.makePutRequest("v1/my/account/footprints", body, true)
        .then(() => {
          this.logger.info(`Successfully posted user footprints for user: ${username}`);
        })
        .catch((err) => {
          this.logger.error(err);
        });
    });
  }
}
